<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#64B9B0"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Detalhes do Evento - {{ lead ? lead : 'visitante' }}</li>
        </ol>
        
        <v-card>
          <div class="timeline">
            <b-avatar size="6rem" class="mx-4" style="transform: translate(-357%, 0%);"></b-avatar>
            <div v-for="(item, index) in timeline" :key="item.horas" class="component">
              <template>
                <div class="lines-right"></div>
                <div class="linesContainer linesContainer-right">
                  <template v-if="index !== 0">
                    <div class="eye-horas">
                      <img src="../../../assets/img/eye.png" alt="" class="eye">
                      <p class="horas">{{ item.horas.split(' ')[1] }}</p>
                    </div>
                  </template>
                  <template v-else>
                      <div class="eye-horas" style="transform: translate(64.5%, -37%);">
                        <p class="horas">{{ item.horas.split(' ')[0] }}</p>
                        <img src="../../../assets/img/eye.png" alt="" class="eye" style="margin-top: 50px">
                        <p class="horas">{{ item.horas.split(' ')[1] }}</p>
                      </div>
                  </template>
                  <div class="visualizacaoContainer">
                    <p v-if="item.visualizacao.split('/')[1].length > 1">
                      <span>Página:</span> {{ item.visualizacao.split('/')[1] }}
                    </p>
                    <p v-else>
                      <span>Página:</span> comprodonto
                    </p>
                    <p v-if="item.visualizacao.split('/').length >= 3">
                      <span>Parâmetros:</span> {{ item.visualizacao.split('/').splice(2).join('/') }}
                    </p>
                  </div>
                </div>
                <div v-if="item.acoes.length > 0" class="actionsContainer-right">
                  <div v-for="(action, index) in item.acoes" :key="index" class="actions-right">
                    <template v-if="index !== 0">
                      <img src="../../../assets/img/arrow.svg" alt="" class="arrow">
                      <p class="action-right">{{  action  }}</p>
                    </template>
                    <template v-else>
                      <img src="../../../assets/img/arrow.svg" alt="" class="arrow">
                      <img src="../../../assets/img/click.png" alt="" class="click">
                      <img src="../../../assets/img/arrow.svg" alt="" class="arrow">
                      <p class="action-right">{{  action  }}</p>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao  } from "@/utils/util";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      isLoading: false,
      lead: '',
      timeline: []
    };
  },
  mounted() {
     var self = this;
     self.isLoading = true;

    ajax("get", `/leads/${self.$route.params.id}`)
      .then(response => {
        self.lead = response.nome;
        self.isLoading = false;
      })
      .catch(error => {
        self.isLoading = false;
       tratamento_requisicao(error, this);
      });

    ajax("get", `/eventos_sites/leads/${self.$route.params.id}`)
      .then(response => {
        self.timeline = response;
        self.isLoading = false;
      })
      .catch(error => {
        self.isLoading = false;
       tratamento_requisicao(error, this);
      });
  },

};
</script>

<style scoped>
  .timeline{
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    padding: 2em;
    padding-bottom: 60em;
    margin-bottom: 1em;
  }
  .component{
    border-left: 2px solid #AF104C;
  }
  .timeline .component:first-of-type .lines-right{
    margin-top: 200px;
  }
  .linesContainer{
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 600px;
    height: 160px;
  }
  .linesContainer-right{
    transform: translate(-24%, -55%);
  }
  .lines-right{
    margin-top: 50px;
    width: 110px;
    border-left: 2px solid #AF104C;
    border-bottom: 2px solid #AF104C;
  }
  .linesContainer p {
    margin: 0;
    text-align: center;
  }
  .eye{
    width: 40px;
    display: flex; 
    justify-content: center; 
    align-items: center;
    margin-bottom: 15px;
    padding: 5px; 
    border-radius: 50%; 
    border: 2px solid #AF104C;
    background-color: #fff;
    box-shadow: 3px 2px 5px rgba(0, 0, 0, 0.35);;
  }
  .eye-horas{
    display: flex; 
    flex-direction: column; 
    align-items: center;
    transform: translate(64.5%, -28%);
    width: 125px;
  }
  .horas{
    font-size: .9em;
    border: 2px solid #AF104C;
    padding: 2px 5px;
    background-color: #fff;
    width: 100px;
    border-radius: 5px;
    box-shadow: 3px 2px 5px rgba(0, 0, 0, 0.35);;
  }
  .visualizacaoContainer{
    display: flex;
    flex-flow: column;
    align-items:  flex-start;
    justify-content: space-around;
    background-color: #fff;
    border: 2px solid #AF104C;
    border-radius: 10px;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.35);;
    height: 120px;
    width: 360px;
    padding: .5em;
  }
  .visualizacaoContainer p{
    width: 200px;
    padding: auto 1em;
    text-align: left;
  }
  .visualizacaoContainer p:nth-child(2){
    display: flex;
    flex-flow: column;
    width: 350px;
    padding: auto 1em;
    text-align: left;
  }
  .visualizacaoContainer p span{
    font-weight: 600;
  }
  .actionsContainer-right{
    width: 200px;
    display: flex;
    flex-flow: column;
    align-items: center;
    transform: translate(90%, -90px);
  }
  .actions-right{
    display: flex;
    flex-flow: column;
    align-items: center;
  }
  .click{
    padding: 5px; 
    border-radius: 50%; 
    border: 2px solid #AF104C;
    box-shadow: 3px 2px 5px rgba(0, 0, 0, 0.35);;
  }
  .action-right{
    padding: 1em;
    border-radius: 50%;
    border: 2px solid #AF104C;
    box-shadow: 5px 3px 5px rgba(0, 0, 0, 0.35);;
    width: 180px;
    text-align: center;
    font-size: 12px;
    margin-bottom: 0;
  }
  .actions-right .action-right:first-child{
    margin-top: .3em;
  }
  .arrow{
    width: 10px;
    margin: .5em 0;
  }
</style>